module.exports = __webpack_public_path__ + "img/pro_five_10.e63c6760.jpg";